import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals = {} }) {

  const labour = Number(totals.Labour) || 0;
  const freight = Number(totals.freight) || 0;
  const proforma = Number(totals.proforma) || 0;

  const drr = Number(totals.DRR) || 0;
  const returnstore = Number(totals.ReturnStore) || 0;
  const elec = Number(totals.ElectricalJV) || 0;



  

  const firstTotal = labour + freight + proforma;
const secondTotal=drr+returnstore+elec;


  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
      <TableContainer>
      <Table
        size="small"
        sx={{
           mb: 10,
          tableLayout: "fixed",
          width: "100%",
          borderCollapse: "collapse",
          "& td": {
            border: "1px solid #999",
            padding: "6px 10px",
            fontSize: "14px",
           
          },
        }}
      >
        <TableBody>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              LABOUR
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={labour} />
            </TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              FREIGHT
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={freight} />
            </TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              PROFORMA ON COST
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={proforma} />
            </TableCell>
          </TableRow>

          <TableRow
            sx={{
              backgroundColor: "#d9ead3",
              "& td": {
                fontWeight: 800,
              },
            }}
          >
            <TableCell colSpan={2}>
              TOTAL
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#b6d7a8",
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={firstTotal} />
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
      </TableContainer>
<TableContainer>
 <Table
        size="small"
        sx={{
          tableLayout: "fixed",
          width: "100%",
          borderCollapse: "collapse",
          "& td": {
            border: "1px solid #999",
            padding: "6px 10px",
            fontSize: "14px",
          },
        }}
      >
        <TableBody>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              DRR
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={drr} />
            </TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              RETURN STORE
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={returnstore} />
            </TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
            <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
              ELEC. MANUFATURING
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#fff2cc",
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={elec} />
            </TableCell>
          </TableRow>

          <TableRow
            sx={{
              backgroundColor: "#d9ead3",
              "& td": {
                fontWeight: 800,
              },
            }}
          >
            <TableCell colSpan={2}>
              TOTAL
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#b6d7a8",
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={secondTotal} />
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
     </TableContainer>
    </Paper>
  );
}